import React from 'react';
import type { VariableTypeDetermination, ShapeValue, DataType } from '@glueapp/graph-types';
import { ShapeValueEditor } from './ShapeValueEditor/ShapeValueEditor';
import { cn } from '@/lib/utils';

export const VariableTypeInput: React.FC<{
    dataType: DataType | undefined;
    typeDetermination: VariableTypeDetermination;
    onChange: (typeDetermination: VariableTypeDetermination, dataType: DataType | undefined) => void;
}> = ({ dataType, typeDetermination, onChange }) => {
    return (
        <div className="flex flex-col gap-2 pt-2">
            <div className="flex flex-row">
                <button
                    type="button"
                    className={cn(
                        'flex-1 px-3 py-2 text-sm font-medium border border-r-0 border-border rounded-l-md transition-colors',
                        typeDetermination === 'FIXED'
                            ? 'bg-primary text-primary-foreground'
                            : 'bg-background text-foreground hover:bg-muted',
                    )}
                    onClick={() => onChange('FIXED', dataType ?? { kind: 'string' })}
                >
                    Fixed Type
                </button>
                <button
                    type="button"
                    className={cn(
                        'flex-[2] px-3 py-2 text-sm font-medium border border-border rounded-r-md transition-colors whitespace-nowrap',
                        typeDetermination === 'INFERRED'
                            ? 'bg-primary text-primary-foreground'
                            : 'bg-background text-foreground hover:bg-muted',
                    )}
                    onClick={() => onChange('INFERRED', undefined)}
                >
                    Figure type out for me
                </button>
            </div>
            {dataType ? (
                <ShapeValueEditor
                    type={{ kind: 'shape', restriction: undefined }}
                    value={{ type: dataType, isShapeValue: true }}
                    onChange={(value: ShapeValue) => onChange(typeDetermination, value.type)}
                />
            ) : null}
        </div>
    );
};
